export enum AddressFormat {
  /** Uses the full formatted address */
  Formatted = 'Formatted',
  /** Displays only the street component of the address */
  Street = 'Street',
  /** Displays the street, postal code, and city components of the address */
  StreetCity = 'StreetCity',
}
